module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/YK4352_logo.985013eb.png";